/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GrantableRoleResponse } from '../models/GrantableRoleResponse';
import type { LoginUserResponse } from '../models/LoginUserResponse';
import type { PasswordUpdateForm } from '../models/PasswordUpdateForm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LoginUserRepository {

  /**
   * ログインユーザ情報取得
   * @returns LoginUserResponse OK
   * @throws ApiError
   */
  public static detail(): CancelablePromise<LoginUserResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/login_user',
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 付与可能ロール情報取得
   * @returns GrantableRoleResponse OK
   * @throws ApiError
   */
  public static grantableRole(): CancelablePromise<Array<GrantableRoleResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/login_user/grantable_role',
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * パスワード変更
   * @returns any OK
   * @throws ApiError
   */
  public static updatePassword({
    requestBody,
  }: {
    requestBody: PasswordUpdateForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login_user/password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

}
